<template>
  <div>
    <center class="loading-medium" v-show="loading">
      <loading></loading>
    </center>
    <div class="content content-new" ng-show="!loading">
      <div class="container-fluid">
        <div v-if="success_message != '' && success_message!=null">
          <div class="alert alert-success text-center">
            <strong>{{success_message}}</strong>
          </div>
        </div>
        <div
          v-if="(upload_error_message!=null && upload_error_message !='')"
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{upload_error_message}}</strong>
        </div>
        <div
          v-if="errorMessage!=null && errorMessage!=''"
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{errorMessage}}</strong>
        </div>
        <div>
          <h3>Exchange Rates</h3>
          <div class="form-group form-inline custom-width">
            <input
              type="search"
              class="form-control"
              placeholder="Search"
              style="margin-right: 4px;"
              v-model="Search"
            />
            <date-pick
              style="margin-left:4px;margin-right:4px"
              :format="'DD-MM-YYYY'"
              v-model="SelectDate"
              :inputAttributes="{class: 'form-control',placeholder:'Select Date'}"
            ></date-pick>
            <button class="btn btn-primary" @click="ChangePageSizeORSearch">Search</button>
            <button class="btn btn-primary" style="margin-left:4px;" @click="Print">Print</button>

            <div class="pull-right">
              <label data-ng-repeat="file in files" style="font:smaller">{{FileName}}</label>
              <input
                type="file"
                ref="file"
                @change="previewFiles"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                style="display:none"
              />

              <div
                class="btn btn-primary"
                style="margin-right: 4px;"
                @click="$refs.file.click()"
              >Select Excel File</div>
              <button class="btn btn-primary" @click="UploadFIle">Upload</button>
            </div>
            <br />
            <br />
            <pre
              v-if="fileLoading"
              style=" display: flex;align-content:center; justify-content: center;flex-direction: row;"
            >
              <loading v-if="fileLoading"></loading>
             <span> {{UPLOADLOG}}</span>
            </pre>
          </div>
          <div id="printable" v-if="errorMessage != ''">
            <label>Price Date: {{priceDate}} &nbsp;&nbsp; Uploaded On: {{UploadOn}}</label>
            <table class="table table-bordered ng-grid">
              <thead style="background:#efeeed;">
                <tr>
                  <th>No.</th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Name')">Name</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='Name'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('USD')">USD</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='USD'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('GBP')">GBP</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='GBP'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('EUR')">EUR</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='EUR'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('CAD')">CAD</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='CAD'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('AUD')">AUD</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='AUD'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('BHD')">BHD</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='BHD'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('KWD')"
                      ng-click="orderProp='KWD'; reverseSort = !reverseSort"
                    >KWD</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='KWD'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('QAR')">QAR</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='QAR'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('SAR')">SAR</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='SAR'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('AED')">AED</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='AED'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  data-ng-repeat="er in ExchangeRates"
                  v-for="(er,index) in ExchangeRates"
                  :key="index+1"
                >
                  <td></td>
                  <td>
                    <strong>{{er.Name == '' ? 'Exchange Rate' : er.Name}}</strong>
                  </td>
                  <td align="right">{{er.USD | number(0)}}</td>
                  <td align="right">{{er.GBP | number(3)}}</td>
                  <td align="right">{{er.EUR | number}}</td>
                  <td align="right">{{er.CAD | number}}</td>
                  <td align="right">{{er.AUD | number}}</td>
                  <td align="right">{{er.BHD | number}}</td>
                  <td align="right">{{er.KWD | number}}</td>
                  <td align="right">{{er.QAR | number}}</td>
                  <td align="right">{{er.SAR | number}}</td>
                  <td align="right">{{er.AED | number}}</td>
                </tr>
                <tr v-for="(comp,index) in OrderBy" :key="index+10">
                  <td>{{index + 1}}</td>
                  <td>{{comp.Name}}</td>
                  <td align="right">{{comp.USD | number(0) }}</td>
                  <td align="right">{{comp.GBP|number(0) }}</td>
                  <td align="right">{{comp.EUR|number(0) }}</td>
                  <td align="right">{{comp.CAD|number(0) }}</td>
                  <td align="right">{{comp.AUD|number(0) }}</td>
                  <td align="right">{{comp.BHD |number(0)}}</td>
                  <td align="right">{{comp.KWD|number(0) }}</td>
                  <td align="right">{{comp.QAR|number(0) }}</td>
                  <td align="right">{{comp.SAR|number(0) }}</td>
                  <td align="right">{{comp.AED|number(0) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import { setTimeout } from "timers";
import DatePick from "vue-date-pick";
export default {
  data() {
    return {
      SelectedPageSize: 10,
      success_message: null,
      currentPage: 1,
      Search: null,
      currentSort: "Name",
      curentSortOrder: "asc",
      FileName: "",
      upload_error_message: null,
      file: null,
      SelectDate: null
    };
  },
  components: {
    DatePick
  },
  methods: {
    //common

    ChangeOrder(key) {
      if (key == this.currentSort) {
        this.curentSortOrder = this.curentSortOrder == "asc" ? "desc" : "asc";
      } else {
        this.curentSortOrder = "asc";
      }
      this.currentSort = key;
      this.ChnageUrl();
    },
    clickCallback: function(page) {
      if (page) {
        this.currentPage = page;
        this.ChnageUrl();
        this.GetData();
      }
    },

    ChnageUrl() {
      var Url =
        "?page=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&dir=" +
        this.curentSortOrder +
        "&sort=" +
        this.currentSort +
        "&dt=" +
        this.SelectDate;
      this.$router.push({ path: "" + Url });
    },
    ChangePageSizeORSearch() {
      this.currentPage = 1;
      this.ChnageUrl();
      this.GetData();
    },
    Print() {
      this.printData("printable", "Exchange Rates");
    },
    ExportCSV() {
      // this.ObjectToCSV(
      //   "Exchange Rates.csv",
      //   this.VendorData,
      //   ["Name", "Type", "Address", "ContactNo"],
      //   ["Name", "Type", "Address", "Contact Number"]
      // );
    },
    //till here
    GetData() {
      var Url =
        "?currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&dt=" +
        (this.SelectDate == null || this.SelectDate == ""
          ? null
          : this.GetCorrectFormat(this.SelectDate));

      var vm = this;
      this.$store
        .dispatch(ACTIONS.GET_ALL_UPLOAD_PRICES, Url)
        .then(res => {
          // this.$refs.paginate.selected = vm.currentPage - 1;
        })
        .catch(err => {});
    },
    UploadFIle() {
      var vm = this;
      if (this.checkFile()) {
        this.$store
          .dispatch(ACTIONS.UPLOAD_COMMODITY_PRICES, this.file)
          .then(res => {
            var { data } = res;

            vm.FileName = "";
            vm.file = null;
            vm.$refs.file.value = "";
            if (data && data.StatusCode == 200) {
              vm.success_message = "Uploaded successfully";
              setTimeout(function() {
                vm.success_message = null;
              }, 1500);
              vm.GetData();
            }
          })
          .catch(err => {
            vm.FileName = "";
            vm.file = null;
            vm.$refs.file.value = "";
          });
      } else {
        this.upload_error_message = "Please Select file";
        setTimeout(function() {
          vm.upload_error_message = null;
        }, 1500);
      }
    },

    previewFiles: function(event) {
      var vm = this;
      this.upload_error_message = null;
      var files = event.target.files;
      if (files && files.length > 0) {
        if (this.checkFile()) {
          this.file = event.target.files[0];
          this.FileName = this.$refs.file.files[0].name;
        } else {
          this.upload_error_message = "File format is not Valid";
          setTimeout(function() {
            vm.upload_error_message = null;
          }, 1500);
        }
      } else {
        this.FileName = "";
        this.$refs.file.value = "";
        //  this.upload_error_message = null;
        this.file = null;
      }
    },
    checkFile() {
      var file = this.$refs.file.files[0];
      if (file && file.name) {
        var validExts = new Array(".xlsx", ".xls");
        var fileExt = file.name.substring(file.name.lastIndexOf("."));
        if (validExts.indexOf(fileExt) < 0) {
          return false;
        }
        return true;
      }
      return false;
    }
  },
  beforeMount() {
    if (this.$route.query) {
      if (this.$route.query.hasOwnProperty("pagesize")) {
        this.SelectedPageSize = this.$route.query["pagesize"];
      }
      if (this.$route.query.hasOwnProperty("search")) {
        this.Search = this.$route.query["search"];
      }
      if (this.$route.query.hasOwnProperty("page")) {
        this.currentPage = this.$route.query["page"];
      }

      if (this.$route.query.hasOwnProperty("sort")) {
        this.currentSort = this.$route.query["sort"];
      }
      if (this.$route.query.hasOwnProperty("dir")) {
        this.curentSortOrder = this.$route.query["dir"];
      }
      if (this.$route.query.hasOwnProperty("dt")) {
        this.SelectDate = this.$route.query["dt"];
      }
    }

    this.GetData();
  },

  computed: {
    ...mapGetters({
      PRICES: "GETPRICES",
      TotalRecords: "TotalPages",
      errorMessage: "UPLOADERROR",
      loading: "UPLOADPRICESLOADING",
      priceDate: "PRICEDATE",
      UploadOn: "UPLOADON",
      ExchangeRates: "EXCHANGERATES",
      fileLoading: "FILELOADING",
      UPLOADLOG: "UPLOADLOG"
    }),
    OrderBy() {
      var data = [...this.PRICES];
      if (data && data.length > 0) {
        var SortedArray = this.Sort(
          data,
          this.currentSort,
          this.curentSortOrder
        );
        return SortedArray;
      }
      return data;
    }
  }
};
</script>